import { render, staticRenderFns } from "./ArticleFeedback.vue?vue&type=template&id=4e7a8582&scoped=true"
import script from "./ArticleFeedback.vue?vue&type=script&lang=js"
export * from "./ArticleFeedback.vue?vue&type=script&lang=js"
import style0 from "./ArticleFeedback.vue?vue&type=style&index=0&id=4e7a8582&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a8582",
  null
  
)

/* custom blocks */
import block0 from "./ArticleFeedback.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports